<script lang="ts">
    import type {DirectoryInsight} from 'typings/portaro.be.types';
    import type {AuthorityDetailReactivePageData, AuthorityDetailStaticPageData,} from '../types';
    import {exists} from 'shared/utils/custom-utils';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import KpAuthorityDetailTabset from '../../kp-authority-detail-tabset/KpAuthorityDetailTabset.svelte';

    const pageContext = getPageContext<AuthorityDetailStaticPageData, AuthorityDetailReactivePageData>();

    const model = pageContext.staticData.model;
    let directoryInsight: DirectoryInsight | undefined;
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => directoryInsight = data.directoryInsight);
    onDestroy(reactiveDataUnsubscribe);
</script>

{#if exists(directoryInsight)}
    <div class="tabset-container">
        <KpAuthorityDetailTabset record={model.record}
                                 tabsConfiguration={model.authorityTabsConfiguration}
                                 directoryInsight={directoryInsight}
                                 marcFields={model.fields}
                                 detailTableRows={model.record.detailTableRows}
                                 showInformationTab={model.showRecordInformationTab}/>
    </div>
{/if}